<template>
  <div class="box">
    <slot></slot>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss">
  .box {
    position: relative;
    padding: 24px;
    background-color: #ffffff;
    box-shadow: 0 19px 21px -1px rgba(10, 31, 68, 0.25);
    border-radius: 4px;
  }
</style>
